import React from 'react'
import Name from '@/components/Name'
import Resx from '@/components/Resx'
import { Link } from 'react-router-dom'
import { formatDate } from '@/utils/dateUtilities'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'

const RelatedReportSubmissionGroups = ({ relatedSubmissionGroups }) => {
  if (relatedSubmissionGroups && relatedSubmissionGroups.length) {
    return (
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tickets.RelatedReportSubmissionGroups' /></InfoLabel>
        <InfoContent>{relatedSubmissionGroups.map((group, idx) => <div key={idx}>
          <Link to={`/report-submission-groups/${group.reportInstanceGroupId}/report-submissions`}>
            {group.institution && <span><Name data={{ name: group.institution.name, latinName: group.institution.latinName }} /> - </span>}<Name data={group} /> ({formatDate(group.snapshotDate)})
          </Link>
        </div>)}</InfoContent>
      </InfoRow>
    )
  }
  return null
}

export {
  RelatedReportSubmissionGroups
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/relatedReportSubmissionGroups.js